<button mat-stroked-button style="margin-right: 10px;" *ngFor="let btn of column.option" [color]="btn?.color" (click)="button_onClick(btn)">
  <mat-icon>{{btn.icon}}</mat-icon>
</button>
<!-- <button mat-stroked-button color="primary" (click)="onClick('Edit')">
  <mat-icon>edit</mat-icon>
</button>
<button mat-stroked-button color="accent" style="margin-left: 10px;" (click)="onClick('Delete')">
  <mat-icon>delete</mat-icon>
</button> -->